<template>
    <div @click="click($event)" class="calendar" ref="clickOutside">
      <div class="date-wrap">
        <input class="present-input"
               :class="{ 'large': getWindowSettings.showFullCalendarDate }"
               type="text"
               :placeholder="placeholder"
               :disabled="disabledData"
               @focus="showPicker = true"
               v-model="inputValue" />
        <svg @click="openPicker()" width="18px" height="20px" class="calendar-icon">
            <use xlink:href="../../../assets/images/sprite.svg#calendar"></use>
        </svg>
      </div>

      <div class="date-duration multy" @click="closePicker()">
        <span class="grey-text">{{localizeList.nightsFrom}}</span>
        <!-- <div class="popover"
              @mouseleave="hidePopover()"
              @mouseenter="showPopover(localizeList.selecteDates, $event)"> -->
            <base-select  :durationSelect="false"
                          :items="daysCountFrom"
                          :disabled="!selectedDate.length"
                          :isDuration="true"
                          :max-height="256"
                          @change="cashFrom($event, true)"
                          @toggle="checkShow($event)"
                          v-model="dayFrom"/>
        <!-- </div> -->
        <span class="grey-text">{{localizeList.nightsTo}}</span>
        <!-- <div class="popover"
              @mouseleave="hidePopover()"
              @mouseenter="showPopover(localizeList.selecteDates, $event)"> -->
            <base-select  :durationSelect="false"
                          :items="daysCountTo"
                          :disabled="!selectedDate.length"
                          :isDuration="true"
                          :max-height="256"
                          @change="cashTo($event)"
                          @toggle="checkShow($event)"
                          v-model="dayTo"/>
        <!-- </div> -->
        <span v-if="dayMode < 2" class="grey-text mr-2">
            {{dayMode === 1 ? localizeList.nights : localizeList.days}}
        </span>
        <span v-else-if="dayMode === 2" class="grey-text mr-2"> 
          {{localizeList.nights}} <br> {{localizeList.inHotel}}
        </span>
      </div>

        <!-- <div v-show="showPicker" @click="closePicker()" class="bg-effect"></div> -->
        <div v-show="showPicker" class="date-picker">
            <div class="date-header multy">
                <h3>{{localizeList.selecteDates}}</h3>
                <div class="selected-date-wrap">
                    <div v-for="(item, key) in selectedDate"
                         :key="key"
                         class="selected-date">
                        <span>{{item.text}}</span>
                        <svg @click="removeSelectedDate(key)" class="close-icon">
                            <use xlink:href="../../../assets/images/sprite.svg#close"></use>
                        </svg>
                    </div>
                </div>
            </div>

            <div class="date-body">
                <div class="date date-1">
                    <div class="date-slider">
                        <div v-if="!firstMonthSelected" @click="sldeDate('left')" class="date-slider-btn left-btn">
                            <svg width="9px" height="14px">
                                <use xlink:href="../../../assets/images/sprite.svg#angle"></use>
                            </svg>
                        </div>
                        <div v-else class="date-slider-cap"></div>
                        <p class="date-month-year">
                            {{firstMonthYear}}
                        </p>
                    </div>

                    <div class="date-weeks">
                        <span v-for="(item, key) in weeks"
                              :key="key">
                            {{item}}
                        </span>
                    </div>

                    <div ref="firstMonth"
                         @mouseleave="unHover()"
                         class="date-month">
                        <div v-for="(item, key) in firstDaysCount"
                             :key="key"
                             @mouseover="hover(item, 1)"
                             @click="selectDay(item)"
                             :class="['date-day',{'active': item.isActive}, {'checked': item.isChecked}, {'fill': item.isFill}, isRound(firstDaysCount, key)]">
                            {{item.day}}
                        </div>
                    </div>

                </div>

                <div class="date date-2">
                    <div class="date-slider">
                        <p class="date-month-year">{{secondMonthYear}}</p>
                        <div @click="sldeDate('right')" class="date-slider-btn">
                            <svg width="9px" height="14px">
                                <use xlink:href="../../../assets/images/sprite.svg#angle"></use>
                            </svg>
                        </div>
                    </div>

                    <div class="date-weeks">
                        <span v-for="(item, key) in weeks"
                              :key="key">
                            {{item}}
                        </span>
                    </div>

                    <div ref="secondMonth"
                         @mouseleave="unHover()"
                         class="date-month">
                        <div v-for="(item, key) in secondDaysCount"
                             :key="key"
                             @mouseover="hover(item, 2)"
                             @click="selectDay(item, true)"
                             :class="['date-day',{'active': item.isActive}, {'checked': item.isChecked}, {'fill': item.isFill}, isRound(secondDaysCount, key)]">
                            {{item.day}}
                        </div>
                    </div>

                </div>
            </div>
            <div class="date-footer">
                <p class="footer-title">{{localizeList.dateControlInfoInner}}</p>
                <div class="footer-buttons">
                    <base-button v-show="selectedDate.length"
                                @click.native="clear()"
                                background="var(--lighten-6-color)"
                                color="#727272">
                        {{localizeList.resetFlightsUpper}}
                    </base-button>
                    <base-button @click="done()"
                                :disabled="!selectedDate.length">
                        {{localizeList.applyUpper}}
                    </base-button>
                </div>
            </div>
        </div>
        <base-alert v-if="!alertDisabled" 
                    @close="removeAlertShow()"
                    :closable="alertContent === 'duration' || alertContent === 'date'">
            <div @mouseover="alertOver()"
                 @mouseleave="alertLeave()">
                <template v-if="alertContent === 'info' && localizeList.dateControlInfo">
                    <p class="standard-text">
                        {{localizeList.dateControlInfo.split(".")[0] + "."}}
                    </p>
                    <p class="standard-text mb-3">
                        {{localizeList.dateControlInfo.split(".")[1] + "."}}
                    </p>
                    <div class="justify-end">
                        <p @click="removeAlertShow(true)" class="blue-text-small pointer alert-not-show">
                            {{localizeList.doNotShowAgain}}
                        </p>
                    </div>
                </template>
                <template v-else-if="alertContent === 'duration'">
                    <p class="standard-text mb-3" style="max-width: 300px">
                        {{localizeList.maximumNumberOfDurations}} {{maxDuration}}
                    </p>
                </template>
                <template v-else-if="alertContent === 'date'">
                    <p class="standard-text mb-3" style="max-width: 300px">
                        {{localizeList.maximumNumberOfDates}} {{maxDates}}
                    </p>
                </template>
            </div>
        </base-alert>
    </div>
</template>

<script>
    import moment from 'moment'
    import {bus} from '../../../main.js'

    export default {
        name: "calendar",
        data() {
            return {
                showPicker: false,
                weeks: [],
                current: moment().format("YYYY-MM-DD"),
                firstMonthYear: "",
                secondMonthYear: "",
                dataDate: {
                    dates: []
                },
                selectedDate: [],
                daysCountFrom: [],
                daysCountTo: [],
                dayFrom: "",
                dayTo: "",
                disabledData: false,
                inputValue: "",
                cash: {
                    dayFrom: "",
                    dayTo: "",
                },
                hoverDayFirst: null,
                hoverDaySecond: null,
                ctrlActive: false,
                keyMove: {
                    position: null,
                    month: 1,
                    isShow: true
                },
                selectShow: false,
                isShowAlert: true,
                alertDisabled: true,
                alertHovered: false,
                alertContent: 'info',
                showPickerCounter: 0, // Счетчик нужен для правильной работы первого клика в календаре (при уже выбронной однорй дате)
                manualСhangeDurationFromFlag: false // //Пришлось сделать для того, чтобы сообщение об изменении продолжительностей не появлялось при смене страны в которой нет таких значений
            }
        },
        props: {
            placeholder: {
                type: String
            },
            activeDates: {
                type: Array,
                default: () => []
            },
            disabled: {
                type: Boolean,
                default: false
            },
            focusFromParent: {
                type: Boolean,
                default: false
            },
            daysCount: {
                type: Array,
                default: () => []
            },
            dayMode: {
                type: Number,
                default: 0
            },
            value: {
                type: Object,
                default: () => {}
            },
            maxDates: {
                type: Number,
                default: 0
            },
            maxDuration: {
                type: Number,
                default: 0
            },
        },
        created() {
            bus.$on("localizeCode", code => {
                code = code === "ua" ? "uk" : code
                moment.locale(code);
                this.disabledData = this.disabled;
                this.calendarMounted()
            })
        },
        mounted() {
            this.calendarMounted()
            window.addEventListener("click", this.onClickOutside);
        },
        beforeDestroy() {
            window.removeEventListener("click", this.onClickOutside);
        },
        computed: {
            getWindowSettings() {
                return window.settings;
            },
            firstMonthSelected(){
                const currentMonth = moment().month();
                const selectedMonth = new Date(this.current).getMonth()
                return currentMonth === selectedMonth
            },
            firstDaysCount() {
                let res         = [];
                let checkedDate = this.selectedDate.map(x => x.value);
                for (let i = 1; i <= moment(new Date(this.current)).daysInMonth(); i++) {
                    let dayConstuct = {
                        day: (i < 10 ? "0" + i : i),
                        isActive: false,
                        isChecked: false,
                        isFill: false,
                    }
                    if (checkedDate.includes(moment(new Date(this.current)).format("YYYY-MM-") + (i < 10 ? "0" + i : i))) {
                        dayConstuct.isChecked = true
                    }
                    if (this.activeDates.includes((i < 10 ? "0" + i : i) + moment(new Date(this.current)).format(".MM.YYYY")) || !this.activeDates.length) {
                        if (!this.activeDates.length) {
                            let currentDate   = moment(new Date()).format("YYYY-MM-DD");
                            let constructDate = moment(new Date(this.current)).format("YYYY-MM-") + (i < 10 ? "0" + i : i);
                            if (constructDate >= currentDate) {
                                dayConstuct.isActive = true
                            }
                        } else {
                            dayConstuct.isActive = true
                        }
                    }

                    if (this.keyMove.isShow && this.keyMove.month === 1 && this.keyMove.position == (i < 10 ? "0" + i : i)) {
                        dayConstuct.isFill = true;
                    }

                    if (this.hoverDayFirst && dayConstuct.isActive && this.selectedDate.length) {
                        if (this.hoverDayFirst.to === "all_right") {
                            if (i >= this.hoverDayFirst.day) {
                                dayConstuct.isFill = true
                            }
                        } else if (this.hoverDayFirst.to === "right") {
                            if (i >= this.hoverDayFirst.day && i < +this.selectedDate[0].value.split("-")[2]) {
                                dayConstuct.isFill = true
                            }
                        } else if (this.hoverDayFirst.to === "all_left") {
                            if (i <= this.hoverDayFirst.day) {
                                dayConstuct.isFill = true
                            }
                        } else if (this.hoverDayFirst.to === "left") {
                            if (i <= this.hoverDayFirst.day && i > +this.selectedDate[0].value.split("-")[2]) {
                                dayConstuct.isFill = true
                            }
                        } else if (this.hoverDayFirst.to === "all") {
                            dayConstuct.isFill = true
                        }
                    }
                    if (this.keyMove.month === 2) {
                        dayConstuct.isFill = false
                    }
                    res.push(dayConstuct)
                }
                return res
            },
            secondDaysCount() {
                let res         = [];
                let checkedDate = this.selectedDate.map(x => x.value);
                for (let i = 1; i <= moment(new Date(this.current)).add(1, 'M').daysInMonth(); i++) {
                    let dayConstuct = {
                        day: (i < 10 ? "0" + i : i),
                        isActive: false,
                        isChecked: false,
                        isFill: false,
                    }
                    if (checkedDate.includes(moment(new Date(this.current)).add(1, 'M').format("YYYY-MM-") + (i < 10 ? "0" + i : i))) {
                        dayConstuct.isChecked = true
                    }
                    if (this.activeDates.includes((i < 10 ? "0" + i : i) + moment(new Date(this.current)).add(1, 'M').format(".MM.YYYY")) || !this.activeDates.length) {
                        if (!this.activeDates.length) {
                            let currentDate   = moment(new Date()).format("YYYY-MM-DD");
                            let constructDate = moment(new Date(this.current)).add(1, 'M').format("YYYY-MM-") + (i < 10 ? "0" + i : i);
                            if (constructDate >= currentDate) {
                                dayConstuct.isActive = true
                            }
                        } else {
                            dayConstuct.isActive = true
                        }
                    }

                    if (this.hoverDaySecond && dayConstuct.isActive && this.selectedDate.length) {
                        if (this.hoverDaySecond.to === "all_right") {
                            if (i >= this.hoverDaySecond.day) {
                                dayConstuct.isFill = true
                            }
                        } else if (this.hoverDaySecond.to === "right") {
                            if (i >= this.hoverDaySecond.day && i < +this.selectedDate[0].value.split("-")[2]) {
                                dayConstuct.isFill = true
                            }
                        } else if (this.hoverDaySecond.to === "all_left") {
                            if (i <= this.hoverDaySecond.day) {
                                dayConstuct.isFill = true
                            }
                        } else if (this.hoverDaySecond.to === "left") {
                            if (i <= this.hoverDaySecond.day && i > +this.selectedDate[0].value.split("-")[2]) {
                                dayConstuct.isFill = true
                            }
                        } else if (this.hoverDaySecond.to === "all") {
                            dayConstuct.isFill = true
                        }
                    }
                    res.push(dayConstuct)
                }
                return res
            },
        },
        methods: {
            onClickOutside(event) {
              const clickOutside = this.$refs.clickOutside;
              if (!clickOutside || clickOutside.contains(event.target)) return;
              this.closePicker();
            },
            checkShow(status) {
              this.selectShow = status;
              if(!status) this.$emit("select-close", 'duration')
            },
            openPicker() {
                if (!this.disabledData)
                    this.showPicker = true
            },
            calendarMounted() {
                this.disabledData = this.disabled;
                if (this.dayMode === 1 || this.dayMode === 2) {
                    this.daysCountFrom = this.daysCount.map(x => {
                        const label = x.label - 1 === 0 ? "<1" : x.label - 1;
                        x.value = x.value - 1;
                        x.label = label;
                        return x
                    });
                    this.daysCountTo = this.daysCountFrom;
                } else {
                    this.daysCountFrom = this.daysCount;
                    this.daysCountTo = this.daysCount;
                }
                let localCode = localStorage.getItem("localize")|| document.getElementById('defaultLanguageCode').value;
                localCode = localCode === "ua" ? "uk" : localCode
                moment.locale(localCode);
                this.weeks = []
                for (let i = 1; i <= 7; i++) {
                    let day = "2020-06-" + `0${i}`;
                    let week = moment(day).format("ddd")
                    this.weeks.push(week)
                }

                this.firstMonthYear = this.dateFormat(this.current, "MMMM YYYY")
                this.secondMonthYear = moment(new Date(this.current)).add(1, 'M').format("MMMM YYYY");

                if (this.value.dates && this.value.dates.length) {

                    this.selectedDate = this.value.dates.map(x => {
                        let res = {
                            text: moment(new Date(this.correctDate(x))).format("DD MMM"),
                            value: this.correctDate(x)
                        }
                        return res
                    });

                    this.cashFrom({
                        value: this.value.daysCount.from
                    })
                    this.cashTo({
                        value: this.value.daysCount.to
                    })
                    this.setValue();
                }

                this.dataDate = this.value
                this.setFirstDayInMonth()
            },
            keyDown(e) {
                if (!this.showPicker) {
                    return
                }
                /* TAB EVENT */
                if (e.keyCode === 9) {
                    this.closePicker()
                    this.$emit("press-tab", e)
                }
                if (e.ctrlKey) {
                    this.ctrlActive = true
                }
                if (this.selectShow) {
                    e.preventDefault()
                    return
                }
                /* MOVE CONTROLE */
                this.keyMove.month = 1;
                let monthCount     = moment(new Date(this.current)).daysInMonth();
                if (e.keyCode === 39 && this.keyMove.position < monthCount) {
                    this.keyMove.position++;
                    e.preventDefault()
                } else if (e.keyCode === 39){
                    this.sldeDate("right");
                    this.keyMove.position = 1;
                    this.keyMove.month = 1;
                    e.preventDefault()
                }
                if (e.keyCode === 37 && this.keyMove.position > 1) {
                    this.keyMove.position--;
                    e.preventDefault()
                } else if (e.keyCode === 37) {
                    this.sldeDate("left");
                    this.keyMove.month = 1;
                    let newMonthCount = moment(new Date(this.current)).daysInMonth();
                    this.keyMove.position = newMonthCount
                    e.preventDefault()
                }
                if (e.keyCode === 40) {
                    e.preventDefault()
                    if ((+this.keyMove.position + 7) <= monthCount) {
                        this.keyMove.position = +this.keyMove.position + 7;
                    }
                }
                if (e.keyCode === 38) {
                    e.preventDefault()
                    if ((+this.keyMove.position - 7) > 0) {
                        this.keyMove.position = +this.keyMove.position - 7;
                    }
                }
                let hoverItem = this.firstDaysCount.find(x => x.day == (this.keyMove.position < 10 ? "0" + this.keyMove.position : this.keyMove.position));
                if (hoverItem) {
                    this.hover(hoverItem, 1)
                }
                if (e.keyCode === 13) {
                    let item = this.firstDaysCount.find(x => {
                        return x.day == (this.keyMove.position?.length < 2 ? "0" + this.keyMove.position : this.keyMove.position)
                    });
                    if (item) {
                        this.selectDay(item)
                    }
                }
            },
            keyUp(e) {
                if (!this.showPicker) {
                    return
                }

                if (!e.ctrlKey) {
                    this.ctrlActive = false
                }
            },
            setAlertDisabled(time) {
                this.alertDisabled = false;
                setTimeout(() => {
                    if (!this.alertHovered)
                        this.alertDisabled = true
                }, time)
            },
            alertOver() {
                if (this.showPicker && this.isShowAlert) {
                    this.setAlertDisabled(99999999999);
                    this.$store.dispatch("A_SET_ALERT",99999999999);
                    this.alertHovered = true;
                }
            },
            alertLeave() {
                if (this.showPicker && this.isShowAlert) {
                    this.setAlertDisabled(1000);
                    this.$store.dispatch("A_SET_ALERT",1000);
                    this.alertHovered = false;
                }
            },
            showPopover(text, e) {
                if (!this.selectedDate.length) {
                    let rect = e.target.getBoundingClientRect()
                    let res  = {
                        x: rect.left + (rect.width / 2),
                        y: rect.top,
                        text: text
                    }
                    this.$store.dispatch("A_SHOW_POPOVER",res)
                }
            },
            correctDate(date) {
                let res = date.split(".").reverse().join("-")
                return res
            },
            click(e) {
                this.$emit("click", e)
            },
            isRound() {
                return "";
                // if (arr[key].isFill && arr[key - 1] && !arr[key - 1].isFill && arr[key + 1] && !arr[key + 1].isFill) {
                //     return "round-all"
                // }
                // if (arr[key].isFill && arr[key - 1] && !arr[key - 1].isFill) {
                //     return "round-left"
                // }
                // if(arr[key].isFill && arr[key + 1] && !arr[key + 1].isFill) {
                //     return "round-right"
                // }
            },
            setValue() {
                if (this.selectedDate.length) {
                    const firstDate = this.selectedDate[0].text;
                    const fullDate = this.getWindowSettings.showFullCalendarDate ? `${firstDate} – ${this.selectedDate.at(-1).text}` : `${firstDate}, +${this.selectedDate.length - 1}`
                    this.inputValue = this.selectedDate.length > 1 ? fullDate : firstDate
                }
            },
            done() {
                this.setValue();
                let inputData = {
                    dates: this.selectedDate.map(x => moment(x.value, "YYYY-MM-DD").format("DD.MM.YYYY")),
                    daysCount: {
                        from: this.dayFrom,
                        to: this.dayTo,
                    }
                };
                this.$emit("input", inputData);
                if (this.showPicker) {
                    this.showPicker = false;
                }
                if (inputData.dates.length) {
                    document.cookie = `hotelsTourDate=${JSON.stringify(inputData)}; path=/`
                  // localStorage.setItem("tourDate", JSON.stringify(inputData));
                }
            },
            clear(changeDuration = true) {
                this.selectedDate = [];
                this.inputValue   = "";
                if (changeDuration) this.dayFrom = "" ;
                if (changeDuration) this.dayTo = "";
            },
            removeSelectedDate(key) {
                this.selectedDate = this.selectedDate.filter((x, i) => key !== i)
            },
            unHover() {
                this.hoverDayFirst  = null;
                this.hoverDaySecond = null;
                this.keyMove.isShow = true;
            },
            hover(item, month) {
                if (!this.ctrlActive && item.isActive && this.selectedDate.length === 1 && this.showPickerCounter !== 0) {
                    this.keyMove.isShow = false
                    let hoverDate       = null;
                    if (month === 1) {
                        hoverDate = moment(new Date(this.current)).format("YYYY-MM") + "-" + item.day;
                        if (this.selectedDate[0].value > hoverDate) {
                            if (this.selectedDate[0].value.split("-")[0] > hoverDate.split("-")[0]) {
                                this.hoverDayFirst = {
                                    day: item.day,
                                    month,
                                    to: "all_right"
                                }
                                if (this.selectedDate[0].value.split("-")[1] > "01") {
                                    this.hoverDaySecond = {
                                        day: null,
                                        month: month + 1,
                                        to: "all"
                                    }
                                } else {
                                    this.hoverDaySecond = {
                                        day: this.selectedDate[0].value.split("-")[2],
                                        month: month + 1,
                                        to: "all_left"
                                    }
                                }
                            } else {
                                if (this.selectedDate[0].value.split("-")[1] > hoverDate.split("-")[1]) {
                                    this.hoverDayFirst = {
                                        day: item.day,
                                        month,
                                        to: "all_right"
                                    }
                                    if (this.selectedDate[0].value.split("-")[1] - 1 > hoverDate.split("-")[1]) {
                                        this.hoverDaySecond = {
                                            day: null,
                                            month: month + 1,
                                            to: "all"
                                        }
                                    } else {
                                        this.hoverDaySecond = {
                                            day: this.selectedDate[0].value.split("-")[2],
                                            month: month + 1,
                                            to: "all_left"
                                        }
                                    }
                                } else {
                                    this.hoverDayFirst = {
                                        day: item.day,
                                        month,
                                        to: "right"
                                    }
                                    this.hoverDaySecond = null;
                                }
                            }
                        } else {
                            this.hoverDaySecond = null;
                            if (this.selectedDate[0].value.split("-")[1] < hoverDate.split("-")[1]) {
                                this.hoverDayFirst = {
                                    day: item.day,
                                    month,
                                    to: "all_left"
                                }
                            } else {
                                this.hoverDayFirst = {
                                    day: item.day,
                                    month,
                                    to: "left"
                                }
                            }
                        }
                    } else {
                        hoverDate = moment(new Date(this.current)).add(1, "M").format("YYYY-MM") + "-" + item.day;
                        if (this.selectedDate[0].value > hoverDate) {
                            if (this.selectedDate[0].value.split("-")[1] > hoverDate.split("-")[1]) {
                                this.hoverDaySecond = {
                                    day: item.day,
                                    month,
                                    to: "all_right"
                                }
                            } else {
                                this.hoverDaySecond = {
                                    day: item.day,
                                    month,
                                    to: "right"
                                }
                            }
                            this.hoverDayFirst = null;
                        } else {
                            if (this.selectedDate[0].value.split("-")[0] < hoverDate.split("-")[0]) {
                                this.hoverDaySecond = {
                                    day: item.day,
                                    month,
                                    to: "all_left"
                                }
                                if (hoverDate.split("-")[1] > "01") {
                                    this.hoverDayFirst = {
                                        day: null,
                                        month: 12,
                                        to: "all"
                                    }
                                } else {
                                    this.hoverDayFirst = {
                                        day: this.selectedDate[0].value.split("-")[2],
                                        month: 12,
                                        to: "all_right"
                                    }
                                }
                            } else {
                                if (this.selectedDate[0].value.split("-")[1] < hoverDate.split("-")[1]) {
                                    this.hoverDaySecond = {
                                        day: item.day,
                                        month,
                                        to: "all_left"
                                    }
                                    if (this.selectedDate[0].value.split("-")[1] < hoverDate.split("-")[1] - 1) {
                                        this.hoverDayFirst = {
                                            day: null,
                                            month,
                                            to: "all"
                                        }
                                    } else {
                                        this.hoverDayFirst = {
                                            day: this.selectedDate[0].value.split("-")[2],
                                            month,
                                            to: "all_right"
                                        }
                                    }
                                } else {
                                    this.hoverDaySecond = {
                                        day: item.day,
                                        month,
                                        to: "left"
                                    }
                                    this.hoverDayFirst = null;
                                }
                            }
                        }
                    }
                } else {
                    this.unHover()
                }
            },
            selectDay(item, secondMonth = false) {
                if (item.isActive) {
                    let selectedDate = null;
                    if (secondMonth) {
                        selectedDate = moment(new Date(this.current)).add(1, 'M').format("YYYY/MM/") + item.day;
                    } else {
                        selectedDate = moment(new Date(this.current)).format("YYYY/MM/") + item.day;
                    }

                    if (this.ctrlActive) {
                        let date = {
                            value: moment(new Date(selectedDate)).format("YYYY-MM-DD"),
                            text: moment(new Date(selectedDate)).format("DD MMM")
                        }
                        if (item.isChecked) {
                            this.selectedDate = this.selectedDate.filter(x => x.value !== date.value);
                        } else {
                            this.selectedDate.push(date)
                        }
                        this.selectedDate = this.$store.getters['quicksort'](this.selectedDate, "value")
                        return
                    }

                    if (!this.selectedDate.length) {
                        let date = {
                            value: moment(new Date(selectedDate)).format("YYYY-MM-DD"),
                            text: moment(new Date(selectedDate)).format("DD MMM")
                        }
                        this.selectedDate.push(date)
                        this.showPickerCounter =+ 1
                    } else if (this.selectedDate.length > 1 || this.showPickerCounter === 0) {
                        this.clear(false);
                        let date = {
                            value: moment(new Date(selectedDate)).format("YYYY-MM-DD"),
                            text: moment(new Date(selectedDate)).format("DD MMM")
                        }

                        this.$nextTick(() => {
                          this.selectedDate.push(date)
                        })

                        this.showPickerCounter =+ 1
                    } else {
                        selectedDate = selectedDate.split("/").join("-");

                        let firstSelectedDate = this.selectedDate[0].value;
                        let firstDay          = +firstSelectedDate.split("-")[firstSelectedDate.split("-").length - 1];
                        let day               = +selectedDate.split("-")[selectedDate.split("-").length - 1];
                        let firstMonth        = +firstSelectedDate.split("-")[1];
                        let month             = +selectedDate.split("-")[1];
                        let firstYear         = +firstSelectedDate.split("-")[0];
                        let year              = +selectedDate.split("-")[0];

                        if (firstSelectedDate < selectedDate) {
                            if (firstYear < year) {
                                while (firstYear < year) {
                                    while (firstMonth <= 12) {
                                        firstDay         = firstMonth > +firstSelectedDate.split("-")[1] ? 1 : firstDay;
                                        let currentMonth = firstYear + `/${firstMonth}/1`;

                                        for (let i = firstDay; i <= moment(new Date(currentMonth)).daysInMonth(); i++) {
                                            i = i < 10 ? "0" + i : i;
                                            let date = firstSelectedDate.split("-")[0] + `/${firstMonth}` + `/${i}`
                                            let dateObj = {
                                                value: moment(new Date(date)).format("YYYY-MM-DD"),
                                                text: moment(new Date(date)).format("DD MMM")
                                            }
                                            if (!this.selectedDate.map(x => x.value).includes(dateObj.value) && (this.activeDates.includes(moment(new Date(date)).format("DD.MM.YYYY")) || !this.activeDates.length)) {
                                                this.selectedDate.push(dateObj)
                                            }
                                        }
                                        firstMonth++
                                    }
                                    firstYear++
                                }
                                firstMonth = 1;
                                while (firstMonth < month) {
                                    firstDay = 1;
                                    let currentMonth = year + `/${firstMonth}/1`;

                                    for (let i = firstDay; i <= moment(new Date(currentMonth)).daysInMonth(); i++) {
                                        i = i < 10 ? "0" + i : i;
                                        let date = year + `/${firstMonth}` + `/${i}`
                                        let dateObj = {
                                            value: moment(new Date(date)).format("YYYY-MM-DD"),
                                            text: moment(new Date(date)).format("DD MMM")
                                        }
                                        if (!this.selectedDate.map(x => x.value).includes(dateObj.value) && (this.activeDates.includes(moment(new Date(date)).format("DD.MM.YYYY")) || !this.activeDates.length)) {
                                            this.selectedDate.push(dateObj)
                                        }
                                    }
                                    firstMonth++
                                }
                                let i = 0;
                                while (i < day) {
                                    i++
                                    let date = year + `/${month}` + `/${i}`
                                    let dateObj = {
                                        value: moment(new Date(date)).format("YYYY-MM-DD"),
                                        text: moment(new Date(date)).format("DD MMM")
                                    }
                                    if (!this.selectedDate.map(x => x.value).includes(dateObj.value) && this.activeDates.includes(moment(new Date(date)).format("DD.MM.YYYY"))) {
                                        this.selectedDate.push(dateObj)
                                    }
                                }
                            } else {
                                if (firstMonth < month) {
                                    while (firstMonth < month) {
                                        firstDay = firstMonth > +firstSelectedDate.split("-")[1] ? 1 : firstDay;
                                        let currentMonth = firstSelectedDate.split("-")[0] + `/${firstMonth}/1`;

                                        for (let i = firstDay; i <= moment(new Date(currentMonth)).daysInMonth(); i++) {
                                            i = i < 10 ? "0" + i : i;
                                            let date = firstSelectedDate.split("-")[0] + `/${firstMonth}` + `/${i}`
                                            let dateObj = {
                                                value: moment(new Date(date)).format("YYYY-MM-DD"),
                                                text: moment(new Date(date)).format("DD MMM")
                                            }
                                            if (!this.selectedDate.map(x => x.value).includes(dateObj.value) && (this.activeDates.includes(moment(new Date(date)).format("DD.MM.YYYY")) || !this.activeDates.length)) {
                                                this.selectedDate.push(dateObj)
                                            }
                                        }
                                        firstMonth++
                                    }
                                    let i = 0;
                                    while (i < day) {
                                        i++
                                        let date = firstSelectedDate.split("-")[0] + `/${month}` + `/${i}`
                                        let dateObj = {
                                            value: moment(new Date(date)).format("YYYY-MM-DD"),
                                            text: moment(new Date(date)).format("DD MMM")
                                        }
                                        if (!this.selectedDate.map(x => x.value).includes(dateObj.value) && (this.activeDates.includes(moment(new Date(date)).format("DD.MM.YYYY")) || !this.activeDates.length)) {
                                            this.selectedDate.push(dateObj)
                                        }
                                    }
                                } else {
                                    while (firstDay < day) {
                                        firstDay++
                                        let date = firstSelectedDate.split("-").slice(0, -1).join("/") + `/${firstDay}`
                                        let dateObj = {
                                            value: moment(new Date(date)).format("YYYY-MM-DD"),
                                            text: moment(new Date(date)).format("DD MMM")
                                        }
                                        if (!this.selectedDate.map(x => x.value).includes(dateObj.value) && (this.activeDates.includes(moment(new Date(date)).format("DD.MM.YYYY")) || !this.activeDates.length)) {
                                            this.selectedDate.push(dateObj)
                                        }
                                    }
                                }
                            }
                        } else if (firstSelectedDate > selectedDate) {
                            if (firstYear > year) {
                                while (firstYear > year) {
                                    while (month <= 12) {
                                        day = month > +selectedDate.split("-")[1] ? 1 : day;
                                        let currentMonth = year + `/${month}/1`;

                                        for (let i = day; i <= moment(new Date(currentMonth)).daysInMonth(); i++) {
                                            i = i < 10 ? "0" + i : i;
                                            let date = selectedDate.split("-")[0] + `/${month}` + `/${i}`
                                            let dateObj = {
                                                value: moment(new Date(date)).format("YYYY-MM-DD"),
                                                text: moment(new Date(date)).format("DD MMM")
                                            }
                                            if (!this.selectedDate.map(x => x.value).includes(dateObj.value) && (this.activeDates.includes(moment(new Date(date)).format("DD.MM.YYYY")) || !this.activeDates.length)) {
                                                this.selectedDate.push(dateObj)
                                            }
                                        }
                                        month++
                                    }
                                    year++
                                }
                                month = 1;
                                while (month < firstMonth) {
                                    day              = 1;
                                    let currentMonth = year + `/${month}/1`;

                                    for (let i = day; i <= moment(new Date(currentMonth)).daysInMonth(); i++) {
                                        i = i < 10 ? "0" + i : i;
                                        let date = year + `/${month}` + `/${i}`
                                        let dateObj = {
                                            value: moment(new Date(date)).format("YYYY-MM-DD"),
                                            text: moment(new Date(date)).format("DD MMM")
                                        }
                                        if (!this.selectedDate.map(x => x.value).includes(dateObj.value) && (this.activeDates.includes(moment(new Date(date)).format("DD.MM.YYYY")) || !this.activeDates.length)) {
                                            this.selectedDate.push(dateObj)
                                        }
                                    }
                                    month++
                                }
                                let i = 0;
                                while (i < firstDay) {
                                    i++
                                    let date    = year + `/${month}` + `/${i}`
                                    let dateObj = {
                                        value: moment(new Date(date)).format("YYYY-MM-DD"),
                                        text: moment(new Date(date)).format("DD MMM")
                                    }
                                    if (!this.selectedDate.map(x => x.value).includes(dateObj.value) && (this.activeDates.includes(moment(new Date(date)).format("DD.MM.YYYY")) || !this.activeDates.length)) {
                                        this.selectedDate.push(dateObj)
                                    }
                                }
                            } else {
                                if (month < firstMonth) {
                                    while (month < firstMonth) {
                                        day              = month > +selectedDate.split("-")[1] ? 1 : day;
                                        let currentMonth = selectedDate.split("-")[0] + `/${month}/1`;

                                        for (let i = day; i <= moment(new Date(currentMonth)).daysInMonth(); i++) {
                                            i = i < 10 ? "0" + i : i;
                                            let date    = selectedDate.split("-")[0] + `/${month}` + `/${i}`
                                            let dateObj = {
                                                value: moment(new Date(date)).format("YYYY-MM-DD"),
                                                text: moment(new Date(date)).format("DD MMM")
                                            }
                                            if (!this.selectedDate.map(x => x.value).includes(dateObj.value) && (this.activeDates.includes(moment(new Date(date)).format("DD.MM.YYYY")) || !this.activeDates.length)) {
                                                this.selectedDate.push(dateObj)
                                            }
                                        }
                                        month++
                                    }
                                    let i = 0;
                                    while (i < firstDay) {
                                        i++
                                        let date    = selectedDate.split("-")[0] + `/${month}` + `/${i}`
                                        let dateObj = {
                                            value: moment(new Date(date)).format("YYYY-MM-DD"),
                                            text: moment(new Date(date)).format("DD MMM")
                                        }
                                        if (!this.selectedDate.map(x => x.value).includes(dateObj.value) && (this.activeDates.includes(moment(new Date(date)).format("DD.MM.YYYY")) || !this.activeDates.length)) {
                                            this.selectedDate.push(dateObj)
                                        }
                                    }
                                } else {
                                    while (day < firstDay) {
                                        let date    = selectedDate.split("-").slice(0, -1).join("/") + `/${day}`
                                        let dateObj = {
                                            value: moment(new Date(date)).format("YYYY-MM-DD"),
                                            text: moment(new Date(date)).format("DD MMM")
                                        }
                                        if (!this.selectedDate.map(x => x.value).includes(dateObj.value) && (this.activeDates.includes(moment(new Date(date)).format("DD.MM.YYYY")) || !this.activeDates.length)) {
                                            this.selectedDate.push(dateObj)
                                        }
                                        day++
                                    }
                                }
                            }
                        } else {
                            this.clear()
                        }
                    }
                    this.selectedDate = this.$store.getters['quicksort'](this.selectedDate, "value")
                    this.$emit("change", this.selectedDate.map(x => moment(x.value, "YYYY-MM-DD").format("DD.MM.YYYY")))

                    this.$nextTick(() => { // Для обновления продолжительности при клике по дням
                      let inputData = {
                        dates: this.selectedDate.map(x => moment(x.value, "YYYY-MM-DD").format("DD.MM.YYYY")),
                        daysCount: {
                            from: this.dayFrom,
                            to: this.dayTo,
                        }
                     };
                     this.$emit("input", inputData);
                    })
                }
            },
            dateFormat(date, format) {
                return moment(new Date(date)).format(format)
            },
            closePicker() {
                this.showPicker = false;
                //this.done();
                // this.setAlertDisabled(0);
                // this.$store.dispatch("A_SET_ALERT", 0)
            },
            setFirstDayInMonth() {
                if (!this.$refs.firstMonth || !this.$refs.secondMonth) {
                    return
                }
                const firstMonth = parseInt(moment(new Date(this.current)).startOf('month').format('E'));
                const secondMonth = parseInt(moment(new Date(this.current)).add(1, 'M').startOf('month').format('E'));

                this.$refs.firstMonth.childNodes[0].style.gridColumnStart  = firstMonth;
                this.$refs.secondMonth.childNodes[0].style.gridColumnStart = secondMonth;
            },
            sldeDate(to) {
                this.keyMove.month = 2;
                if (to === 'right') {
                    this.current = moment(new Date(this.current)).locale("ru").add(1, 'M')
                } else {
                    this.current = moment(new Date(this.current)).locale("ru").add(-1, 'M')
                }
            },
            cashFrom(e, checkManualСhangeDuration = false) {
                if (!e || (e.value !== "" && e.value === this.dayFrom)) return;

                this.manualСhangeDurationFromFlag = checkManualСhangeDuration;

                //для того что-бы при загрузке страницы, когда в аргумент функции приходит "" не сбрасывало диапазон при переходе по url
                if (e.value === "") {
                  const checkDurationOfRoute = this.$route.params?.searchParams?.split("&").find(x => x.includes("duration"))
                  const getDuration = checkDurationOfRoute?.split("=")[1]?.split(",");
                  if (getDuration) {
                    if (this.dayMode === 1 || this.dayMode === 2) {
                      this.cash.dayFrom = +getDuration[0] === 0 ? '<1' : +getDuration[0] -1
                      this.dayFrom      = +getDuration[0] === 0 ? '<1' : +getDuration[0] -1
                    } else {
                      this.cash.dayFrom = +getDuration[0] === 0 ? '<1' : +getDuration[0]
                      this.dayFrom      = +getDuration[0] === 0 ? '<1' : +getDuration[0]
                    }
                  } else {
                    return
                  }
                } else {
                  this.cash.dayFrom = e.value
                  this.dayFrom      = e.value
                }

                let inputData = {
                    dates: this.selectedDate.map(x => moment(x.value, "YYYY-MM-DD").format("DD.MM.YYYY")),
                    daysCount: {
                        from: this.dayFrom,
                        to: this.dayTo,
                    }
                }
                //меняем продолжительности в куках при каждом изменении (чтобы при смене места прибытия даты не слетали)
                if (inputData.dates.length) {
                    document.cookie = `hotelsTourDate=${JSON.stringify(inputData)}; path=/`;
                }

                //для того что-бы при смене продолжительности обновлялись данные для запроса (для раздельной реализации контрола дат)
                this.$emit("change-days", {
                showPicker: this.showPicker,
                days: [this.dayFrom, this.dayTo]
              })
            },
            cashTo(e) {
                if (!e) return;

                this.cash.dayTo = e.value
                this.dayTo      = e.value

                let inputData = {
                    dates: this.selectedDate.map(x => moment(x.value, "YYYY-MM-DD").format("DD.MM.YYYY")),
                    daysCount: {
                        from: this.dayFrom,
                        to: this.dayTo,
                    }
                }
                //меняем продолжительности в куках при каждом изменении (чтобы при смене места прибытия даты не слетали)
                if (inputData.dates.length) {
                    document.cookie = `hotelsTourDate=${JSON.stringify(inputData)}; path=/`;
                }

               //для того что-бы при смене продолжительности обновлялись данные для запроса (для раздельной реализации контрола дат)
                this.$emit("change-days", {
                showPicker: this.showPicker,
                days: [this.dayFrom, this.dayTo]
              })
            },
            removeAlertShow(clearStorage = false) {
                this.isShowAlert = false;
                if (clearStorage) localStorage.setItem("notShowAlert", true);
                this.setAlertDisabled(0);
                this.$store.dispatch("A_SET_ALERT", 0)
            }
        },
        watch: {
            localizeList: {
                deep: true,
                handler() {
                    this.setValue()
                }
            },
            value: {
                deep: true,
                handler(val) {
                    // Изменил условие, т.к. после сборса кнопкой ломалось
                    // if (!val || !Object.entries(val).length || !val.dates.length) {
                    if (!val || !Object.entries(val).length) {
                        this.clear();
                    } else {
                        val.dates.forEach(x => {
                            let res = {
                                text: moment(this.correctDate(x), "YYYY-MM-DD").format("DD MMM"),
                                value: this.correctDate(x)
                            }
                            if ((this.activeDates.length && this.activeDates.includes(x) || !this.activeDates.length) &&
                                !this.selectedDate.map(x => x.value).includes(res.value)
                            ) {
                                this.selectedDate.push(res)
                            }
                        });
                        this.cashTo({
                            value: val.daysCount.to
                        })
                        this.cashFrom({
                            value: val.daysCount.from
                        })
                        this.setValue();
                        this.$emit("change", this.selectedDate.map(x => moment(x.value, "YYYY-MM-DD").format("DD.MM.YYYY")));
                    }
                }
            },
            disabled(val) {
                this.disabledData = val
            },
            dayFrom(val) {
                if (val > this.dayTo) {
                    this.cashTo({ value: val })
                    this.dayTo = val
                }

                let cashDay = this.cash.dayFrom
                if (val && cashDay) {
                    this.dayFrom = cashDay
                }

                this.$nextTick(() => {
                    const durations = this.daysCount.filter(x => x.value >= val && x.value <= (this.dayTo || 0));
                    if (this.maxDuration && this.maxDuration < durations.length) {
                        while (this.maxDuration < durations.length) durations.pop();

                        this.cashTo({ value: durations[durations.length-1].value });

                        if (this.manualСhangeDurationFromFlag) {
                            this.alertContent = "duration";
                            this.setAlertDisabled(5000);
                            this.$store.dispatch("A_SET_ALERT", 5000)
                            this.manualСhangeDurationFromFlag = false
                        }
                    }
                })
            },
            dayTo(val) {
                if (val < this.dayFrom) {
                    this.cashFrom({value: val})
                    this.dayFrom = val
                }

                let cashDay = this.cash.dayTo
                if (val && cashDay) {
                    this.dayTo = cashDay
                }

                this.$nextTick(() => {
                    const durations = this.daysCount.filter(x => x.value >= (this.dayFrom || 0) && x.value <= val);

                    if (this.maxDuration && this.maxDuration < durations.length) {
                        while (this.maxDuration < durations.length) durations.shift();
                        this.cashFrom({ value: durations[0].value });

                        this.alertContent = "duration";
                        this.setAlertDisabled(5000);
                        this.$store.dispatch("A_SET_ALERT", 5000)
                    }
                })
            },
            daysCount(val) {
                if (this.dayMode === 1 || this.dayMode === 2) {
                    this.daysCountFrom = val.map(x => {
                        const label = x.label - 1 === 0 ? "<1" : x.label - 1;
                        x.value = x.value - 1;
                        x.label = label;
                        return x
                    });
                    this.daysCountTo = this.daysCountFrom;
                } else {
                    this.daysCountFrom = val
                    this.daysCountTo   = val
                }

                let isIncludeInCashFrom = val.find(x => x.value === this.cash.dayFrom)

                if (!isIncludeInCashFrom && val[0]) {
                    this.cashFrom(val[0])
                } else {
                    this.dayFrom = this.cash.dayFrom
                }

                setTimeout(() => {
                    let isIncludeInCashTo = val.map(x => x.value).includes(this.cash.dayTo)
                    if (!isIncludeInCashTo) {
                        if (this.maxDuration && val[this.maxDuration-1]) {
                            this.cashTo(val[this.maxDuration-1])
                        } else {
                            this.cashTo(val[val.length - 1])
                        }
                    } else {
                        const durations = this.daysCount.filter(x => x.value >= this.dayFrom && x.value <= this.dayTo);
                        if (this.maxDuration && this.maxDuration < durations.length) {
                            while (this.maxDuration < durations.length) durations.pop();

                            this.cashTo({ value: durations[durations.length-1].value });
                        } else {
                            this.dayTo = this.cash.dayTo
                        }
                    }
                    this.$emit("change-days", {
                        showPicker: this.showPicker,
                        days: [this.dayFrom, this.dayTo]
                    })
                }, 0)
            },
            current(val) {
                this.firstMonthYear  = this.dateFormat(val, "MMMM YYYY")
                this.secondMonthYear = moment(new Date(val)).add(1, 'M').format("MMMM YYYY");
                this.setFirstDayInMonth()
            },
            selectedDate: {
                deep: true,
                handler(val) {
                    if (!val.length) {
                        this.daysCountFrom = [];
                        this.daysCountTo = [];
                        this.inputValue = "";
                    } else {
                        this.setValue()
                    }
                    if (this.maxDates && val.length && val.length > this.maxDates) {
                        this.selectedDate.pop();
                        this.alertContent = "date";
                        this.setAlertDisabled(5000);
                        this.$store.dispatch("A_SET_ALERT", 5000);
                    }
                }
            },
            activeDates: {
                deep: true,
                handler(val) {
                    // Выбираем первый активный месяц
                    if(!val.length) return
                    const [actDay, actMonth, actYear] = val[0].split('.')
                    this.current = [actYear, actMonth, actDay].join('-')
                    this.firstMonthYear = this.dateFormat(this.current, "MMMM YYYY")
                    this.secondMonthYear = moment(new Date(this.current)).add(1, 'M').format("MMMM YYYY");

                    // логика выбора первой доступной даты, если в url выбради несуществующую
                    if (!this.value.dates?.length) {
                        const firstFiltered = this.firstDaysCount.find((item) => item?.isActive);
                        const secondFiltered = this.secondDaysCount.find((item) => item?.isActive);
                        if (firstFiltered) {
                            this.selectDay(firstFiltered);
                            this.done();
                        } else if (secondFiltered) {
                            this.selectDay(secondFiltered, true);
                            this.done();
                        } else {
                            this.clear();
                        }
                    }
                    let removedCount = 0;
                    this.selectedDate.forEach((x, i) => {
                        if (!val.map(x2 => this.correctDate(x2)).includes(x.value) && val.length) {
                            this.removeSelectedDate(i-removedCount);
                            removedCount++
                        }
                    });
                }
            },
            focusFromParent(val) {
                if (val) {
                    this.showPicker = true
                }
            },
            showPicker(val) {
                this.showPickerCounter = 0
                if (val) {
                    window.addEventListener('keydown', this.keyDown);
                    window.addEventListener('keyup', this.keyUp);
                    let showAlert = localStorage.getItem("notShowAlert")
                    this.$emit("focus");
                    this.alertContent = "info";
                    if (!showAlert) {
                        this.setAlertDisabled(5000);
                        this.$store.dispatch("A_SET_ALERT", 5000);
                    }
                } else {
                    this.done();
                    window.removeEventListener('keydown', this.keyDown);
                    window.removeEventListener('keyup', this.keyUp);
                    this.$emit("blur");
                }
            }
        }
    }
</script>

<style scoped>
    .calendar {
        position: relative;
        display: flex;
        column-gap: 8px;
    }
    .calendar .date-wrap {
        position: relative;
    }
    .calendar .present-input {
        width: 100%;
        border: none;
        outline: none;
        padding: 8px 40px 8px 12px;
        background-color: var(--lighten-6-color);
        border-radius: 3px;
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        color: #333;
        max-width: 150px;
    }

    .calendar .present-input.large {
        max-width: 200px
    }

    .calendar input::placeholder {
        color: var(--lighten-5-color);
    }

    .calendar .calendar-icon {
        position: absolute;
        top: calc(50% - 10px);
        right: 11px;
    }

    .bg-effect {
        z-index: 100;
        background-color: unset;
    }
    .calendar .date-picker {
        background-color: var(--white-color);
        position: absolute;
        top: 130%;
        left: 50%;
        transform: translateX(-50%);
        box-shadow: 0 5px 15px rgba(0, 0, 0, .5);
        border-radius: 4px;
        z-index: 101;
    }
    .calendar .date-picker .date-header {
        padding: 19px 32px;
        border-bottom: 1px dashed #E0E0E0;
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 4px;
        align-items: center;
    }
    .calendar .date-picker .date-header.multy{
        display: flex;
    }
    .calendar .date-picker .date-header h3 {
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        color: #1D1D1D;
        margin-right: 13px;
        white-space: nowrap;
    }
    .calendar .date-picker .date-header .selected-date-wrap {
        display: flex;
        flex-wrap: wrap;
        max-width: 400px;
    }
    .calendar .date-picker .date-header .selected-date {
        background: var(--green-color);
        border-radius: 3px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 6px;
        height: 32px;
        margin: 0 4px 4px 0;
    }
    .calendar .date-picker .date-header .selected-date span {
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        color: var(--white-color);
    }
    .calendar .date-picker .date-header .selected-date .close-icon {
        width: 9px;
        height: 9px;
        fill: var(--white-color);
        opacity: .7;
        margin-left: 3px;
        cursor: pointer;
    }
    .calendar .date-picker .date-body{
        padding: 16px 32px;
        border-bottom: 1px dashed #E0E0E0;
        display: grid;
        grid-template-columns: 1fr 1fr;
    }
    .calendar .date-picker .date-1{
        margin-right: 32px;
    }
    .calendar .date-body .date-slider{
        display: flex;
        align-items: center;
        margin-bottom: 12px;
    }
    .calendar .date-body .date-2 .date-slider{
        justify-content: flex-end;
    }
    .calendar .date-body .date .date-month-year {
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        text-transform: capitalize;
        color: var(--dark-2-color);
    }
    .calendar .date-body .date-1 .date-month-year{
        margin-left: calc(50% - 28px);
        transform: translateX(-50%)
    }
    .calendar .date-body .date-2 .date-month-year{
        margin-right: calc(50% - 28px);
        transform: translateX(50%)
    }
    .calendar .date-body .date-slider-btn{
        width:28px;
        height:28px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        background-color: var(--lighten-6-color);
        transition: all .2s;
        cursor: pointer;
    }
    .calendar .date-body .date-slider-cap{
        width:28px;
        height:28px;
    }
    .calendar .date-body .date-slider-btn:hover{
        background-color: #e0e0e0;
    }
    .calendar .date-body .date-slider-btn svg{
        fill: var(--dark-1-color);
    }
    .calendar .date-body .date-2 .date-slider-btn {
        transform: rotate(180deg)
    }
    .calendar .date-body .date-weeks {
        display: flex;
        align-items: center;
        justify-content: space-around;
    }
    .calendar .date-body .date-weeks span {
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        color: var(--lighten-7-color);
    }
    .calendar .date-body .date-weeks span:nth-last-child(1),
    .calendar .date-body .date-weeks span:nth-last-child(2) {
        color: var(--green-5-color);
    }
    .calendar .date-body .date-month {
        width: 280px;
        display: grid;
        grid-template-columns: repeat(7, 1fr);
        grid-row-gap: 2px;
    }
    .calendar .date-body .date-month .date-day {
        height: 40px;
        display: flex;
        align-items: center;
        justify-content:center;
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        color: var(--lighten-5-color);
        transition: all .2s;
    }
    .calendar .date-body .date-month .date-day.fill {
        background-color: var(--green-color);
        color: rgba(255, 255, 255, .5);
    }
    .calendar .date-body .date-month .date-day.round-all {
        border-radius: 50%;
    }
    .calendar .date-body .date-month .date-day.round-left {
        border-top-left-radius: 50%;
        border-bottom-left-radius: 50%;
    }
    .calendar .date-body .date-month .date-day.round-right{
        border-top-right-radius: 50%;
        border-bottom-right-radius: 50%;
    }
    .calendar .date-body .date-month .date-day.active {
        background-color: var(--green-3-color);
        color: #1D1D1D;
        cursor: pointer;
    }
    .calendar .date-body .date-month .date-day.active.fill {
        background-color: var(--green-4-color);
        color: var(--white-color);
    }
    .calendar .date-body .date-month .date-day.active:hover {
        background-color: var(--green-4-color);
        color: var(--white-color);
    }
    .calendar .date-body .date-month .date-day.checked {
        background-color: var(--green-2-color);
        color: var(--white-color);
        cursor: pointer;
    }
    .calendar .date-body .date-month .date-day.checked:hover {
        background-color: var(--green-4-color);
    }
    .calendar .date-duration {
        display: grid;
        align-items: center;
        grid-template-columns: auto 1fr auto 1fr auto;
        grid-gap: 8px;
    }
    .calendar .date-duration .duration-select .select {
        padding: 8px 40px 12px 8px;
    }
    /* .calendar .date-duration.multy {
        grid-template-columns: auto auto 1fr auto 1fr 1fr 1fr;
    } */
    /* .calendar .date-duration .title,
    .calendar .date-duration .grey-text{
        font-weight: bold;
        font-size: 15px;
        line-height: 18px;
    }
    .calendar .date-duration .title{
        color: var(--dark-2-color);
    } */
    .calendar .date-duration .grey-text {
        color: #828282;
        line-height: 1;
        font-weight: bold;
        font-size: 15px;
    }
    .calendar .date-duration /deep/.select {
        min-height: 35px;
        width: 60px;
        padding: 8px 30px 8px 11px;
    }
    .calendar .date-footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px 32px;
    }
    .calendar .footer-buttons {
        display: flex;
        column-gap: 8px;
    }
    .calendar .alert-not-show {
        display: inline-block;
    }
</style>
